import React, { useState, useEffect, useContext, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import { useBillDetails } from './useBillDetails';
import { recurringAmount, downloadInvoicePDF } from './myBills.util';
import PDFlogo from '../../images/pdf.png';
import { MobileContext } from '../../global-context';
import { useApolloClient } from '@apollo/client';
import PaymentFlowModal from '../../payment-flow/PaymentFlowModal';
import { publish, subscribe } from 'pubsub-js';
import { ArrowBackIcon } from '../../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';
import EirButton from '../../../theme/EirButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

function BillDetails(props) {
    const classes = useBillDetails();
    const modalTitleRef = useRef(null);
    const containerRef = useRef(null);
    // const [open, setOpen] = useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);

    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = `Bill details`;
    const descriptionId = ` Bill details description`;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const graphql = useApolloClient();
    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        props.setIsOpen(!props.isopen);
    };

    const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
    const [error, setError] = useState(false);
    const [accountNum, setAccountNum] = useState();
    const [issueDate, setIssueDate] = useState('NA');
    const [recurringCharges, setRecurringCharges] = useState('NA');
    const [oneOff, setOneOff] = useState('NA');
    const [usageCharges, setUsageCharges] = useState('NA');
    const [totalBill, setTotalBill] = useState('NA');
    const [hidePDF, setHidePDF] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const token = sessionStorage.getItem('access_token');

    const invoiceId = `${props.invoiceNumber}`;
    useEffect(() => {
        setAccountNum(sessionStorage.getItem('LoggedinUserAccountNumber'));
        setIssueDate(props.invoiceDate);
        recurringAmountUtil();
    }, []);

    const recurringAmountUtil = async () => {
        await recurringAmount({
            graphql,
            token,
            invoiceId,
            setRecurringCharges,
            setOneOff,
            setUsageCharges,
            setTotalBill,
            setError,
        });
    };

    const downloadInvoicePDFUtil = async () => {
        await downloadInvoicePDF({ graphql, invoiceNumber: props.invoiceNumber, setHidePDF });
    };

    function convertDate(str) {
        const dateArr = str?.split('-');
        const myDate = new Date(`${dateArr[0]}-${dateArr[1]}-${dateArr[2]}`);
        const myMonth = myDate.toLocaleString('default', { month: 'short' });
        return `${dateArr[2]} ${myMonth} ${dateArr[0]}`;
    }
    function convertDueDate(str) {
        const strDate = str?.split('T');
        const dateVal = `${strDate[0]}`;
        const dateArr = dateVal.split('-');
        const myDate = new Date(`${dateArr[0]}-${dateArr[1]}-${dateArr[2]}`);
        const myMonth = myDate.toLocaleString('default', { month: 'short' });
        return `${dateArr[2]} ${myMonth} ${dateArr[0]}`;
    }
    function totalPriceMonthandYear(str) {
        const dateArr = str.split('-');
        const myDate = new Date(`${dateArr[0]}-${dateArr[1]}-${dateArr[2]}`);
        const myMonth = myDate.toLocaleString('default', { month: 'short' });
        return `${myMonth} ${dateArr[0]}`;
    }

    const openPayment = () => {
        if (props.isopen) {
            togglePayment();
            publish('paymentModal');
        }
    };

    const toggleClose = () => {
        setArrowclose(true);
    };

    const togglePayment = () => {
        setPaymentModal(!paymentModal);
    };
    console.log('lastbilldue', props.lastBillDueDate);
    // useEffect(() => {
    //     if (props.isopen) {
    //         setTimeout(() => {
    //             modalTitleRef.current?.focus();
    //         }, 0);
    //     }
    // }, [props.isopen]);
    // useEffect(() => {
    //     if (props.isopen) {
    //         document.getElementById(titleId)?.focus();
    //     }
    // }, [props.isopen, titleId]);
    useEffect(() => {
        if (props.isopen) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [props.isopen]);
    return (
        <>
            {/* <Button onClick={handleOpen}>Open modal</Button> */}
            {/* <div className='billDetails' onClick={handleOpen}>See bill details</div> */}
            {/* <div className={'billDetails' + (isopen ? ' open' : '')} onClick={toggle}>
                See bill details
            </div> */}

            <Modal
                className={classes.billDetailsModal}
                isOpen={props.balanceFlag ? props.isopen : props.isopen}
                toggle={props.balanceFlag ? balanceToggle : props.toggle}
                // open={isopen}
                // toggle={toggle}
                modalTransition={{ timeout: 300 }}
                wrapClassName={classes.WrapBillDetails}
                modalClassName={classes.billDetailsmodal}
                role='dialog'
                aria-modal='true'
                aria-labelledby={titleId}
                aria-describedby={descriptionId}
                ref={containerRef}
            >
                <ModalBody className={classes.wrapperstyle}>
                    {/* <ArrowBackIcon style={{ color: theme.palette.primary.sunset }} /> */}
                    <div aria-label='Back to dashboard'>
                        <ArrowBackIcon
                            className={classes.BackIcon}
                            onClick={toggle}
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === '') {
                                    e.preventDefault();

                                    toggle();
                                }
                            }}
                            aria-label='Back to dashboard'
                        />
                    </div>
                    {/* <img className={classes.BackIcon} src={Back} alt="back icon"></img> */}
                    {/* modal-title */}
                    <div className={classes.billAttribute}>
                        <div className={classes.modalTitle}>
                            <Typography
                                className={classes.billDetails}
                                id={titleId}
                                role='heading'
                                aria-level='2'
                                tabIndex='-1'
                                component='h2'
                                variant='h2'
                                // ref={modalTitleRef}
                            >
                                Bill details
                            </Typography>
                            <div className={classes.billDetailImage}>
                                <img
                                    className={classes.PDFIcon + (hidePDF ? ' hide' : ' ')}
                                    src={PDFlogo}
                                    alt=''
                                    onClick={() => {
                                        downloadInvoicePDFUtil(props.invoiceNumber);
                                    }}
                                    tabIndex={0}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === '') {
                                            e.preventDefault();

                                            downloadInvoicePDFUtil(props.invoiceNumber);
                                        }
                                    }}
                                ></img>
                            </div>
                        </div>
                    </div>

                    {/* modal-description */}
                    <div className={classes.modalDescription} id={descriptionId}>
                        <Grid container>
                            <Grid item className={classes.topGrid} sm={12} xs={12} container>
                                <Grid item className={classes.title} sm={6} xs={6}>
                                    Account number
                                </Grid>
                                <Grid item className={classes.value} sm={6} xs={6}>
                                    {accountNum}
                                </Grid>
                            </Grid>

                            <Grid item className={classes.topGrid} sm={12} xs={12} container>
                                <Grid item className={classes.title} sm={6} xs={6}>
                                    Issued on
                                </Grid>
                                <Grid item className={classes.valueBold} sm={6} xs={6}>
                                    {convertDate(issueDate)}
                                </Grid>
                            </Grid>

                            <Grid item className={classes.topGrid} sm={12} xs={12} container>
                                <Grid item className={classes.title} sm={6} xs={6} id='amount'>
                                    Amount
                                </Grid>
                                <Grid
                                    item
                                    className={classes.value}
                                    sm={6}
                                    xs={6}
                                    aria-labelledby='amount'
                                >
                                    {!isNaN(totalBill) && (
                                        <span aria-label={`€${(totalBill / 100).toFixed(2)}`}>
                                            €{(totalBill / 100).toFixed(2)}
                                        </span>
                                    )}
                                </Grid>
                            </Grid>

                            {!isPaymentCompleted &&
                                props.index === 0 &&
                                (JSON.parse(sessionStorage.getItem('myBalance')) / 100).toFixed(2) <
                                    0 && (
                                    <Grid
                                        item
                                        className={classes.topGrid}
                                        sm={12}
                                        xs={12}
                                        container
                                    >
                                        <Grid item className={classes.titleRed} sm={12} xs={12}>
                                            Direct debit due on{' '}
                                            {props.lastBillDueDate === null
                                                ? ' '
                                                : convertDueDate(props.lastBillDueDate)}
                                        </Grid>
                                    </Grid>
                                )}
                            {!isPaymentCompleted &&
                                props.index === 0 &&
                                (JSON.parse(sessionStorage.getItem('myBalance')) / 100).toFixed(2) <
                                    0 && (
                                    <div className={classes.makePayment}>
                                        <EirButton
                                            style={{ width: '11rem' }}
                                            variants='primaryButtonMedium'
                                            // className={classes.paymentButton}
                                            onClick={openPayment}
                                            tabIndex={0}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === '') {
                                                    e.preventDefault();

                                                    openPayment();
                                                }
                                            }}
                                            aria-label='"Make a payment modal window will open"'
                                            role='button'
                                        >
                                            Make a payment
                                        </EirButton>
                                    </div>
                                )}

                            <Grid
                                item
                                className={classes.descriptionAttributeComplete}
                                sm={12}
                                xs={12}
                                container
                            >
                                <Grid
                                    item
                                    className={classes.titleBold}
                                    sm={6}
                                    xs={6}
                                    id='Recurring-charges'
                                >
                                    Recurring charges
                                </Grid>
                                <Grid
                                    item
                                    className={classes.valueAttribute}
                                    sm={6}
                                    xs={6}
                                    aria-labelledby='Recurring-charges'
                                    aria-live='polite'
                                >
                                    {!isNaN(recurringCharges) && (
                                        <span
                                            aria-label={`€${(recurringCharges / 100).toFixed(2)}`}
                                        >
                                            €{(recurringCharges / 100).toFixed(2)}
                                        </span>
                                    )}
                                </Grid>
                                <Grid item className={classes.subAttribute} sm={12} xs={8}>
                                    Includes monthly fees, add ons and part period charges if
                                    applicable
                                </Grid>
                            </Grid>

                            <Grid
                                item
                                className={classes.descriptionAttribute}
                                sm={12}
                                xs={12}
                                container
                            >
                                <Grid item className={classes.titleBold} sm={6} xs={6} id='One-off'>
                                    One off charges
                                </Grid>
                                <Grid
                                    item
                                    className={classes.valueAttribute}
                                    sm={6}
                                    xs={6}
                                    aria-labelledby='One-off'
                                >
                                    {!isNaN(oneOff) && (
                                        <span aria-label={`€${(oneOff / 100).toFixed(2)}`}>
                                            €{(oneOff / 100).toFixed(2)}
                                        </span>
                                    )}
                                </Grid>
                                <Grid item className={classes.subAttribute} sm={12} xs={12}>
                                    Includes one off add ons
                                </Grid>
                            </Grid>

                            <Grid
                                item
                                className={classes.descriptionAttributeUsage}
                                sm={12}
                                xs={12}
                                container
                            >
                                <Grid
                                    item
                                    className={classes.titleBold}
                                    sm={6}
                                    xs={6}
                                    id='usage-charges'
                                >
                                    Usage charges
                                </Grid>
                                <Grid
                                    item
                                    className={classes.valueAttribute}
                                    sm={6}
                                    xs={6}
                                    aria-labelledby='usage-charges'
                                >
                                    {!isNaN(usageCharges) && (
                                        <span aria-label={`€${(usageCharges / 100).toFixed(2)}`}>
                                            €{(usageCharges / 100).toFixed(2)}
                                        </span>
                                    )}
                                </Grid>
                                <Grid item className={classes.subAttribute} sm={12} xs={12}>
                                    Out of bundle charges
                                </Grid>
                            </Grid>

                            <Grid item className={classes.topAttribute} sm={12} xs={12} container>
                                <Grid item className={classes.totalBold} sm={6} xs id='total-bill'>
                                    Total for {totalPriceMonthandYear(issueDate)} bill
                                </Grid>
                                <Grid
                                    item
                                    className={classes.totalValue}
                                    sm={6}
                                    xs={3}
                                    aria-labelledby='total-bill'
                                >
                                    {!isNaN(totalBill) && (
                                        <span aria-label={`€${(totalBill / 100).toFixed(2)}`}>
                                            €{(totalBill / 100).toFixed(2)}
                                        </span>
                                    )}
                                </Grid>
                                <Grid item className={classes.vatValue} sm={12} xs={12}>
                                    VAT included
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    <PaymentFlowModal
                        amount={Math.abs(
                            JSON.parse(sessionStorage.getItem('myBalance')) / 100
                        ).toFixed(2)}
                        open={paymentModal}
                        toggle={togglePayment}
                    />
                </ModalBody>
            </Modal>
        </>
    );
}

export default BillDetails;
